module.exports = __webpack_public_path__ + "img/V-L-135-load-standup-base.0eb57bfb.png";